import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {connect} from 'react-redux'
import {updateResource} from 'redux-json-api'

import ExistingItemPermissionInformation from '../manage_item_permissions/ExistingItemPermissionInformation'
import ManageItemPermissionsModal from '../manage_item_permissions/ManageItemPermissionsModal'
import {selectAllItemIds} from '../../../../../../lib/plan_data/itemSelectors'

import {TextGutterMedium} from '../../../blocks/Texts'

import image from '../../../../../../shared_assets/quarterbackImage.png'

import './everplansConcierge.scss'

const EverplansConcierge = ({quarterbackOwnership, ...otherProps}) => {
  if (quarterbackOwnership.isEmpty()) return null

  return (
    <div className='everplans-concierge'>
      <div className='everplans-concierge__text'>
        <h2>Everplans Concierge</h2>
        <TextGutterMedium>
          Included with your subscription, a member of our Concierge Team will
          help you get started, stay on track, and build a plan that reflects
          your life.
        </TextGutterMedium>
        <ExistingItemPermissionInformation
          name='Everplans Concierge'
          ownership={quarterbackOwnership}
        />
        <ManageItemPermissionsModal
          allItemIds={otherProps.allItemIds}
          isFuneralHome={!quarterbackOwnership.isEmpty()}
          name='Everplans Concierge'
          ownership={quarterbackOwnership}
          updateResource={otherProps.updateResource}
        />
      </div>
      <img alt='' src={image} />
    </div>
  )
}

EverplansConcierge.propTypes = {
  allItemIds: PropTypes.array,
  quarterbackOwnership: PropTypes.instanceOf(Map),
  updateResource: PropTypes.func
}

const mapStateToProps = state => ({allItemIds: selectAllItemIds(state)})

export default connect(mapStateToProps, {updateResource})(EverplansConcierge)
